import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Dialog, DialogContent, DialogTrigger, DialogTitle } from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { search, getCategory } from "@/lib/site";

export const SearchDialog = ({ trigger }) => {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const results = search(q);

  const go = (slug) => {
    setOpen(false);
    setQ("");
    navigate(`/articulo/${slug}`);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <button data-testid="search-open-button" aria-label="Buscar" className="p-2 hover:text-brand-terra transition-colors">
            <Search size={20} />
          </button>
        )}
      </DialogTrigger>
      <DialogContent className="max-w-xl p-0 gap-0 bg-brand-surface">
        <VisuallyHidden><DialogTitle>Buscar artículos</DialogTitle></VisuallyHidden>
        <div className="flex items-center gap-3 border-b border-brand-line px-4 py-3">
          <Search size={18} className="text-brand-sub" />
          <input
            data-testid="search-input"
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Busca destinos, vuelos, trucos…"
            className="flex-1 outline-none text-base bg-transparent text-brand-ink"
          />
        </div>
        <div className="max-h-80 overflow-y-auto">
          {q && results.length === 0 && (
            <p className="px-4 py-6 text-sm text-brand-sub">Sin resultados para “{q}”.</p>
          )}
          {results.map((a) => (
            <button
              key={a.slug}
              data-testid={`search-result-${a.slug}`}
              onClick={() => go(a.slug)}
              className="w-full text-left px-4 py-3 hover:bg-brand-adbg flex items-center gap-3 border-b border-brand-line/50"
            >
              <img src={a.image} alt="" className="w-12 h-12 object-cover rounded" />
              <div>
                <p className="text-sm font-semibold text-brand-ink leading-snug">{a.title}</p>
                <p className="text-xs text-brand-sub">{getCategory(a.categorySlug)?.name}</p>
              </div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
